import {
  Activity, ArrowRight, Bell, ChartNoAxesCombined, Check, ChevronDown, Clock3, Database, Gauge,
  HeartPulse, Home, Layers3, Menu, RefreshCw, Search, Settings2, Sparkles, UsersRound, X,
} from 'lucide-react';

const icons = {
  activity: Activity,
  'arrow-right': ArrowRight,
  alerts: Bell,
  check: Check,
  'chevron-down': ChevronDown,
  clock: Clock3,
  data: Database,
  gauge: Gauge,
  home: Home,
  layers: Layers3,
  menu: Menu,
  refresh: RefreshCw,
  search: Search,
  settings: Settings2,
  sparkles: Sparkles,
  trends: ChartNoAxesCombined,
  users: UsersRound,
  vitality: HeartPulse,
  close: X,
};

export type IconName = keyof typeof icons;

export function Icon({ name, size = 18 }: { name: IconName; size?: number }) {
  const Component = icons[name];
  return <Component aria-hidden="true" size={size} strokeWidth={1.8} />;
}
